export class AnthropicProvider {
  constructor({ baseURL, apiKey, model, temperature = 0.7 }) {
    this.baseURL = (baseURL || 'https://api.anthropic.com').replace(/\/$/, '');
    this.apiKey = apiKey;
    this.model = model;
    this.temperature = temperature;
  }

  async send(messages) {
    const systemParts = messages.filter(m => m.role === 'system');
    const chatMessages = messages.filter(m => m.role !== 'system');
    const system = systemParts.map(m => m.content).join('\n\n');

    const url = `${this.baseURL}/v1/messages`;
    const body = {
      model: this.model,
      max_tokens: 2048,
      temperature: this.temperature,
      system,
      messages: chatMessages,
      stream: false,
    };

    let res;
    try {
      res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': this.apiKey,
          'anthropic-version': '2023-06-01',
        },
        body: JSON.stringify(body),
      });
    } catch (err) {
      const error = new Error(`Network error: ${err.message}`);
      error.name = 'TypeError';
      throw error;
    }

    if (!res.ok) {
      const text = await res.text().catch(() => 'Unknown error');
      const error = new Error(`Anthropic API error ${res.status}: ${text}`);
      error.status = res.status;
      throw error;
    }

    const data = await res.json();
    return data.content?.[0]?.text ?? '';
  }
}
